<template>
  <Form ref="form" :validation-schema="schema" :validation-schema-context="{ phoneValid: phoneIsValid }" @submit="submit" @change="onChange" :initial-values="formData">
    <validated-input placeholder="Entrez votre prénom" label="Prénom" name="firstname" type="text" :required="true" />
    <validated-input placeholder="Entrez votre nom de famille" label="Nom de famille" name="lastname" type="text"
      :required="true" />
    <validated-input placeholder="Entrez votre adresse e-mail" label="Email" name="email" type="email"
      :required="true" />
    <p class="email-alert">⚠️ {{ TEXT_infospam }}</p>
    <PhoneInput name="phone" @validate="phoneIsValid = $event"></PhoneInput>
    <validated-checkbox label=" Réservation pour une entreprise" name="enterprise" />
    <validated-input v-show="form && form.values.enterprise" placeholder="Entrez le nom de l'entreprise"
      label="Nom de l'entreprise" name="enterpriseName" type="text" :required="true" />
    <VatInput v-show="form && form.values.enterprise" placeholder="Entrez votre numéro de TVA" label="Numéro de TVA"
      name="enterpriseNumber" type="text" :required="true" />
    <p v-if="showVatWarning" class="vat-warning">⚠️ Nous n'avons pas pu vérifier l'assujetissement à la TVA de ce numéro BCE</p>
    <validated-input placeholder="Entrez votre nom de rue et numéro" label="Adresse" name="address" type="text"
      :required="form && form.values.enterprise" />
    <validated-input placeholder="Entrez votre code postal" label="Code postal" name="postalCode" :required="true"
      type="text" />
    <validated-input placeholder="Entrez votre localité" label="Localité" name="locality" type="text"
      :required="true" />
    <validated-input placeholder="Entrez votre pays" label="Pays" name="country" type="text" :required="true" />
    <validated-text-area label="Allergènes" name="allergy" type="textarea" />
    <validated-text-area label="Remarques" name="comment" type="textarea" />
    <div class="button-wrapper">
      <button class="btn btn-success" type="submit">submit</button>
      <button @click="reset" class="btn btn-danger" type="button">Reset</button>
    </div>
  </Form>
</template>
<script setup>
import { Form, useForm } from 'vee-validate'
import { onMounted, ref } from 'vue'
import * as yup from 'yup'
import { useTextStore } from "@/stores/texts";
import ValidatedInput from '@/components/input/ValidatedInput.vue'
import ValidatedTextArea from '@/components/input/ValidatedTextArea.vue'
import ValidatedCheckbox from '@/components/input/ValidatedCheckbox.vue'
import { checkVatNumber } from '@/api/api';

defineExpose({
  triggerValidate,
  getValues
});

const textStore = useTextStore();
const euVatRegex = /^[A-Z]{2}[0-9A-Z]{8,12}$/

const form = ref(null)
const phoneIsValid = ref(false);
const showVatWarning = ref(false);
const schema = yup.object({
  firstname: yup.string().required('Le prénom est obligatoire').min(2, "fe"),
  lastname: yup.string().required('Le nom est obligatoire').min(2, "fe"),
  email: yup.string().email().required('L\'email est obligatoire'),
  phone: yup.string().required('Le numéro de téléphone est obligatoire').test('phoneValid', 'Le numéro de téléphone est invalide', function () {
    return phoneIsValid.value;
  }),
  address: yup.string().when('enterprise', {
    is: true,
    then: (schema) => schema.required('L\'adresse est obligatoire')
  }),
  postalCode: yup.string().required('Le code postal est obligatoire'),
  locality: yup.string().required('La localité est obligatoire'),
  country: yup.string().required('Le pays est obligatoire'),
  enterprise: yup.boolean(),
  enterpriseName: yup.string().when('enterprise', {
    is: true,
    then: (schema) => schema.required('Le nom de l\'entreprise est obligatoire')
  }),
  enterpriseNumber: yup.string().when('enterprise', {
    is: true,
    then: (schema) => schema.required('Le numéro de TVA est obligatoire').test(
      'is-valid-vat',
      'Numéro de TVA non valide (vérification via VIES)',
      async function (value) {
        if (!value) return true // skip validation if not both present

        const response = await checkVatNumber(value)

        if (response.success && response.data) {
          console.log('VIES response:', response.data)

          // Check if source is CBE2JSON
          if (response.data?.source === "CBE2JSON") {
            showVatWarning.value = true;
          } else {
            showVatWarning.value = false;
          }

          return response.data.valid;
        } else if (response.error) {
          console.error('VIES error:', response.error.toJSON())
          showVatWarning.value = false;
          return this.createError({
            message: response.error.getUserMessage() || 'Could not validate VAT number'
          })
        }

        showVatWarning.value = false;
        return this.createError({ message: 'Could not validate VAT number' })
      }
    ),
  }),
  allergy: yup.string(),
  comment: yup.string(),
})
useForm({ validationSchema: schema });

const TEXT_infospam = ref("");

const formData = ref({
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  address: '',
  postalCode: '',
  locality: '',
  country: '',
  enterprise: false,
  enterpriseNumber: '',
  enterpriseName: '',
  allergy: '',
  comment: ''
})

onMounted(async () => {
  TEXT_infospam.value = (await textStore.getText("infospam")) || "";
})

function onChange() {
  console.log('values change', form.value, form.value.values, form.value.values.enterprise, formData.value.enterprise, form);

}

function triggerValidate() {
  console.log('triggerValidate', phoneIsValid.value);
  return form.value.validate();
}

function getValues() {
  return form.value.values;
}

function submit(values) {
  // implement your logic here
  //form.value.resetForm()
  console.log('submit', values)
}
const reset = () => {
  form.value.resetForm()
}
</script>
<style scoped>
.btn {
  height: 35px;
  padding: 0px 20px;
  background-color: gray;
  color: white;
  border-radius: 5px;
}

.button-wrapper {
  display: flex;
  gap: 10px;
}

.btn-success {
  background-color: rgb(64, 181, 64);
}

.btn-danger {
  background-color: rgb(186, 17, 17);
}

.email-alert {
  color: rgb(83, 93, 113);
  font-weight: bold;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: -24px !important;
  margin-bottom: 36px !important;
}

.vat-warning {
  color: rgb(255, 140, 0);
  font-weight: bold;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: -24px !important;
  margin-bottom: 36px !important;
  font-size: 0.9em;
}
</style>
